<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="closeSrchDlg">
      <tm-search-list></tm-search-list>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 観測所検索
 * Info.vue
 * @author LIS
 */

/** 観測所検索・結果一覧カード */
import TmSearchList from "../../components/pc/full/TmSearchList.vue";

export default {
  components: {
    TmSearchList
  },
  data() {
    return {};
  },
  methods: {
    /** 観測所検索ダイアログを閉じる */
    closeSrchDlg() {
      this.$store.commit(
        "search/setShowSrchDlg",
        !this.$store.state.search.showSrchDlg
      );
    }
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
</style>
